module.exports = __webpack_public_path__ + "media/auido.0d9a1ab5.mp3";